<script>
  import {isArray} from 'lodash'
  import {VueMaskDirective as mask} from 'v-mask'
  import estadosBr from '../../../../_default/utils/estados-brasileiros'
  import {vinculos} from '../../../../../domain/grv/helpers/helpers-notificacao'
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import ACL from '../../../../../domain/acl/tmp-acl'
  import { buscaCep } from '../../../../../domain/grv/services'
  import {
    find,
    cadastrar,
    situacoes
  } from '../../../../../domain/policia-civil/notificacao-telegrama/services/notificacao-telegrama'

  export default {
    components: {},
    nome: 'nova-cadastro-notificacao-telegrama',
    directives: {mask},
    props: {
      grv: {
        required: true,
        type: Object
      },
      telegramaId: {
        required: false,
        type: Number
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        loadSituacoesText: 'Carregando',
        data: {
          id: null,
          nome: null,
          codigo: null,
          status: false,
          situacao: null
        },
        situacoesArr: [],
        vinculos
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      },
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    created () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        this.data.grv = this.grv.id
        this.situacaoList()
        if (this.telegramaId) {
          this.$parent.loading(true)
          find(this.telegramaId)
            .then((response) => {
              this.$parent.loading(false)
              this.isLoaded = true
              this.data = response.data

              const formataData = date => date ? moment(date.date).format('L LT') : null

              this.data.dataPostagem = formataData(this.data.dataPostagem)
              this.data.dataRetornoAr = formataData(this.data.dataRetornoAr)

              this.ajustaValores()
              console.log(response)
            })
              .catch((response) => {
                this.$parent.loading(false)
                console.log(response)
              })
        } else {
          this.isLoaded = true
        }
      },
      situacaoList () {
        situacoes().then((response) => {
          this.loadSituacoesText = 'Selecione'
          this.situacoesArr = response.data.situacoes
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      pesquisarCep (cep) {
        cep = String(cep).replace(/\D/g, '')
        if (cep.length !== 8) return
        buscaCep(cep)
          .then(({ data }) => {
            this.$set(this.data, 'logradouro', data.logradouro)
            this.$set(this.data, 'bairro', data.bairro)
            this.$set(this.data, 'cidade', data.localidade)
            this.$set(this.data, 'complemento', data.complemento)
            this.$set(this.data, 'uf', data.uf)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        if (inversed) {
          console.log('Inversed fields to data')
        } else {
          this.data.situacao = (typeof this.data.situacao['id'] !== 'undefined') ? this.data.situacao['id'] : this.data.situacao
        }
      },
      submit () {
        if (!(this.data.assinante || '').trim()) return alert('Informe o assinante.')
        this.data.grv = this.grv.id
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$parent.loading(true)
        const data = JSON.parse(JSON.stringify(this.data))
        data.cep = String(data.cep).replace(/\D/g, '')

        cadastrar(data, this.telegramaId).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$parent.loading(false)
            if (this.telegramaId) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
            this.$emit('finishSubmit', true)
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$parent.loading(false)
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Notificação de Processo - Telegrama</h1></div>
          <div class="col-sm-6"> </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{telegramaId && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">

              <input type="hidden" class="form-control" v-model="data.grv" required/>

              <div class="form-group">
                <label class="col-sm-4 control-label">Vínculo</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.vinculo">
                    <option :value="vinculo.id" v-for="vinculo in vinculos">{{vinculo.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cep" @blur="pesquisarCep(data.cep)" v-mask="'##.###-###'" />
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Endereço</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.logradouro"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Bairro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.bairro"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complemento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">UF</label>
                <div class="col-sm-8">
                  <select required class="form-control" v-model="data.uf">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cidade"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Assinante</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.assinante" required/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label" style="font-weight: bold;">AR</label>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data/hora de Postagem</label>
                <div class="col-sm-8">
                  <input id="dataPostagem" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataPostagem"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data/hora de Retorno</label>
                <div class="col-sm-8">
                  <input id="dataRetorno" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataRetornoAr"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Situação</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.situacao">
                    <option value="" disabled>{{loadSituacoesText}}</option>
                    <option v-for="situacao in situacoesArr" v-bind:value="situacao.id">
                      {{situacao.nome}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper" v-if="ACL.check('restrito_visitante', currentUser.id)">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('finishSubmit')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoCadastroNotificacaoTelegrama.vue?3bac5b50